import { useSnapshot } from 'valtio'
import cn from 'classnames'
import lodashCloneDeep from 'lodash/cloneDeep'
import { type ReactElement } from 'react'
import { type MinimumUser, proxyNewUser } from '../../../../../shared/proxies/newUserProxy'
import { TableCell } from '../../../index/RecentSalesActivitySection/RecentActivitySubSection/Components/TableCell'
import { globalUserProxy } from '../../../../../shared/proxies/globalUserProxy'
import { processChange } from '../NewUserForm/utils'
import { FormFieldNamesEnum } from '../NewUserForm/formFieldNamesEnum'

function setEditValues (editValues: MinimumUser): void {
  processChange(editValues.email, FormFieldNamesEnum.Email)
  processChange(editValues.firstName, FormFieldNamesEnum.FirstName)
  processChange(editValues.lastName, FormFieldNamesEnum.LastName)
  processChange(editValues.isAdmin, FormFieldNamesEnum.IsAdmin)
}

export function MerchantUsersTableRows (): ReactElement {
  const { merchantUsers } = useSnapshot(proxyNewUser)
  const { user } = useSnapshot(globalUserProxy)
  return (
    <>
      {merchantUsers.length === 0 && (
        <tr>
          <td colSpan={10}>
            <div className="text-center my-16 text-wpy-gray">
              No Results
            </div>
          </td>
        </tr>
      )}
      {merchantUsers.map((merchantUser, i) => {
        const notLastRow = i !== (proxyNewUser.merchantUsers.length - 1)
        return (
          <tr
            key={merchantUser.id}
            className={
              cn(
                'opacity-90 my-1 text-sm animate__animated animate__fadeIn',
                notLastRow && 'border-b border-gray-100'
              )
            }
          >
            <TableCell>
              {merchantUser.id}
            </TableCell>
            <TableCell>
              {merchantUser.firstName}
            </TableCell>
            <TableCell>
              {merchantUser.lastName}
            </TableCell>
            <TableCell>
              {merchantUser.email}
            </TableCell>
            <TableCell>
              {merchantUser.isAdmin ? 'Yes' : 'No'}
            </TableCell>
            <td className="p-0 h-10 relative">
              <div className="flex">
                <button
                  onClick={async () => {
                    proxyNewUser.selectedUser = lodashCloneDeep(merchantUser)
                    setEditValues(merchantUser)
                    proxyNewUser.displayUserEditModal = true
                  }}
                  className="flex justify-center items-center rounded hover:bg-gray-100 py-2 px-3" style={{ color: '#2A5EC1' }}
                >
                  <div className="ml-4 leading-6">Edit</div>
                </button>

                {merchantUser?.id !== user?.id &&
                  <button
                    onClick={async () => {
                      proxyNewUser.selectedUser = merchantUser
                      proxyNewUser.displayUserDeleteModal = true
                    }}
                    className="flex justify-center items-center rounded hover:bg-gray-100 py-2 px-3"
                    style={{ color: '#F34A61' }}
                  >
                    <div className="ml-4 leading-6">Delete</div>
                  </button>}
              </div>
            </td>
          </tr>
        )
      })}
    </>
  )
}
